import {NgModule} from '@angular/core';

import {OrderByPipe} from './orderBy.pipe';
import {DateFormatPipe} from './date-format.pipe';
import {ContainsPipe} from '@shared/pipes/contains.pipe';
import {UtcToLocalPipe} from '@shared/pipes/utc-to-local.pipe';
import {LocalToUtcPipe} from '@shared/pipes/local-to-utc.pipe';
import {FilterByPipe} from '@shared/pipes/filterBy.pipe';
import {HexToColorPipe} from './hex-to-color.pipe';
import {MultilangPipe} from './multilang.pipe';

@NgModule({
  declarations: [
    OrderByPipe,
    DateFormatPipe,
    UtcToLocalPipe,
    LocalToUtcPipe,
    ContainsPipe,
    FilterByPipe,
    HexToColorPipe,
    MultilangPipe
  ],
  exports: [
    OrderByPipe,
    DateFormatPipe,
    UtcToLocalPipe,
    LocalToUtcPipe,
    ContainsPipe,
    FilterByPipe,
    HexToColorPipe,
    MultilangPipe
  ]
})
export class PipeModule {
}
